export const ruTr = {
  book: 'Забронировать',
  build: 'Сделано',
  close: 'Закрыть',
  continue: 'Продолжить',
  country: 'Страна',
  credit: 'Кредит',
  date: 'Дата',
  day: 'День',
  filter: 'Фильтр',
  name: 'Имя',
  nights: 'ночей',
  no_records: 'Нет записей',
  normal: 'Обычный',
  only_english_input: 'Ввод только на английском языке, как в паспорте',
  pay_processing: 'Идет загрузка платежа и бронь',
  per_person: 'За человека',
  price: 'Цена',
  price_per_person: 'Цена за человека',
  reset: 'Сбросить',
  reset_filters: 'Сбросить фильтры',
  site_name: 'Ophir Tours',
  something_went_wrong: 'Что-то пошло не так',
  success: 'Успешно',
  total: 'Итого',
  total_price: 'Общая стоимость',
  gallery: 'Галерея',
  page_not_found: 'Страница не найдена',
  sold_out: 'Мест нет',
  search: {
    search: 'Искать',
  },
  validation: {
    required: 'Обязательное поле',
  },
  flight: {
    arrival: 'Прилет',
    charter: 'Чартерный рейс',
    departure: 'Вылет',
    informattion_about: 'Информация о перелете',
    airport: 'Аэропорт',
    order_summary: 'Заказ',
    details: 'Детали рейса',
  },
  home: {
    session_expired: 'Сессия истекла',
    session_expired_desc: 'Ваша сессия истекла. Попробуйте снова.',
    go_back: 'Вернуться назад',
  },
  hotel: {
    book: 'Оплата картой',
    paid_successfully: 'Оплата прошла успешно',
  },
  login: {
    contact_us: 'Свяжитесь с нами',
    full_name: 'Полное имя',
    select_number: 'Выберите количество пассажиров',
    get_back: 'Отправить',
    login_your: 'Войдите в свой аккаунт',
    username: 'Имя пользователя',
    password: 'Пароль',
    login: 'Войти',
    success: 'Вы успешно вошли в систему',
    off: 'Выход',
    off_success: 'Вы успешно вышли из системы',
  },
  mo: {
    hello: 'Привет',
    user_code: 'Код пользователя',
    branch: 'Филиал',
    department: 'Отдел',
  },
  op: {
    room_type: 'Тип комнаты',
    hosting_base: 'Тип питания',
    amount: 'Количество',
    flight_details: 'Детали рейса',
    check_in: 'Дата заезда',
    check_out: 'Дата выезда',
    airport: 'Аэропорт',
    numb_of_nights: 'Количество ночей',
  },
  package: {
    price_per_person: 'За человека',
  },
  passenger: {
    details: 'Детали пассажира',
    guest: 'Гость',
    fn: 'Имя',
    ln: 'Фамилия',
    phone: 'Телефон',
    email: 'Электронная почта',
    confirm: 'Подтверждаю, что я ознакомлен(а) с условиями',
    read_more: 'Узнать больше',
    methods_of_payment: 'Способы оплаты',
    fast_secure: 'Быстро и безопасно',
    transaction_type: 'Тип транзакции',
    number_of_payments: 'Количество платежей',
    green_button_tooltip: 'После нажатия на кнопку, вы будете перенаправлены на страницу оплаты',
    send_request_to_consultant: 'Отправить запрос консультанту',
    send_request: 'Отправить запрос',
    confirm_order_text: 'Подтвердить заказ брони',
    confirm_order: 'Отправить запрос',
    id_number: 'Идентификационный номер (9 цифр)',
    passport: 'Номер паспорта',
    passport_valid_till: 'Паспорт действителен до',
  },
  room: {
    type: 'Тип комнаты',
    count: 'Количество комнат',
    choose: 'Выберитe',
    c1: '1 комната',
    c2: '2 комнаты',
    c3: '3 комнаты',
    c4: '4 комнаты',
    c5: '5 комнат',
    c6: '6 комнат',
    c7: '7 комнат',
    c8: '8 комнат',
    c9: '9 комнат',
  },
  guides: {
    title: 'Наши гиды',
    loading: 'Загрузка...',
    empty: 'Гиды не найдены',
    search: 'Поиск',
    search_placeholder: 'Поиск гида по имени',
    search_empty: 'Гиды не найдены по вашему запросу',
    back: 'К списку гидов',
    destinations: 'Направления сопровождения:',
    experience: 'Опыт:',
    education: 'Образование:',
    specialization: 'Специализация:',
    languages: 'Языки:',
    tours: 'Туры:',
    reviews: 'Отзывы:',
    photos: 'Фотографии и письма путешественников',
  },
  tour: {
    additional_info: 'Доп информация',
    all: 'Все туры',
    all_dates: 'Все даты',
    choose_rooms: 'Выберите комнаты',
    display_in_cards: 'Отображать в карточках',
    display_in_list: 'Отображать в списке',
    download_way: 'скачать тур и маршут',
    entrance: 'Въезд',
    exit: 'Выезд',
    guid: 'Гид',
    included: 'Включено',
    info_about: 'Информация о туре',
    nghts: 'Ночей',
    nights: 'Количество ночей',
    not_found: 'Тур не найден, попробуйте другой',
    not_included: 'Не включено',
    options: 'вариантов',
    packages: 'Пакеты',
    tour: 'Тур',
    what_included: 'Что включено',
    in: 'Туры в ',
    choose_date: 'Выберите дату',
    choose_country: 'Выберите страну',
    cancel_information: 'Информация о отмене',
  },
  access: {
    accessibility_settings: 'Настройки доступности',
    internet_accessibility:
      'Доступность интернета означает, что люди с ограниченными возможностями могут использовать интернет',
    contrast: 'Контрастность:',
    dark: 'Темный',
    normal: 'Обычный',
    bright: 'Яркий',
    color: 'Цвет:',
    high: 'Высокий',
    black_white: 'Черно-белый',
    font_size: 'Размер шрифта:',
    clear_selection: 'Очистить выбор',
  },
};
